<template>
  <a-flex class="root">
    <div class="title">
      <p>
        {{ title }}
      </p>
    </div>
    <div class="tags_container">
      <a-flex class="tags_list">
        <tag-item
          v-for="item in items.filter((el) => el.isPlanned)"
          :class="
            (item?.count > 0 && 'active') || (item?.is_selected && 'selected')
          "
          :key="item.id"
          @click="onSelect(item)"
        >
          {{ getFormatedLabel(item.name, item.count) }}
        </tag-item>
      </a-flex>
    </div>

    <div v-if="!!items.filter((el) => !el.isPlanned).length">
      <a-divider class="divider" />
      <a-flex class="tags_list">
        <tag-item
          v-for="item in items.filter((el) => !el.isPlanned)"
          class="secondary"
          :key="item.id"
        >
          {{ getFormatedLabel(item.name, item.count) }}
        </tag-item>
      </a-flex>
    </div>
  </a-flex>
</template>

<script setup>
  import TagItem from '@/components/tags/TagItem.vue';

  defineProps({
    title: String,
    items: {
      type: Array,
      default: () => [],
    },
  });

  const emit = defineEmits(['click']);

  const getFormatedLabel = (label, counter) => {
    if (counter > 1) {
      return `${label} (${counter})`;
    }

    return label;
  };

  const onSelect = (item) => {
    emit('click');
    item.is_selected = !item.is_selected;
  };
</script>

<style scoped lang="scss">
@use "@/assets/styles/_colors.scss" as *;

  .root {
    background-color: $color-bg-secondary-grey;
    border-radius: 7px;
    flex-direction: column;
    max-width: 900px;
    padding: 20px;
    width: 100%;

    .title {
      color: $color-table-text-secondary;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .tags_list {
      flex-wrap: wrap;
      gap: 4px;

      :deep(.tag) {
        background-color: $color-bg-primary-white;
        color: $color-text-primary;
        font-size: 12px;
        padding: 4px 10px !important;
        pointer-events: none;
        user-select: none;

        &:before {
          content: '#';
        }
      }

      .active {
        background-color: $color-bg-status-done;
        color: $color-bg-primary-white;
      }

      .secondary {
        background-color: $color-tag;
        color: $color-bg-primary-white;
      }

      .selected {
        background-color: rgba(114, 200, 30, 0.25);
        border: 1px solid $color-bg-status-done;
        color: $color-text-primary;
      }
    }

    .divider {
      border-color: $color-bg-primary-white;
    }
  }
</style>
